<template>
  <div class="contact-page">
    <!-- 顶部横幅 -->
    <section class="banner-section">
      <img src="@/assets/pic/contact-ban.jpg" alt="联系我们" class="banner-img" />
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">{{ $i18n.t('contact.bannerTitle') }}</h1>
        <p class="banner-subtitle">{{ $i18n.t('contact.bannerDesc') }}</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="main-section">
      <div class="container">
        <!-- 区域标题 -->
        <div class="section-header scroll-animate fade-up" data-delay="0">
          <h2 class="secTitle">{{ $i18n.t('contact.sectionTitle') }}</h2>
          <span>{{ $i18n.t('contact.sectionSub') }}</span>
        </div>

        <!-- 联系方式卡片区域 -->
        <div class="info-layout">
          <!-- 上排：电子邮件 + 在线客服（左右平铺） -->
          <div class="top-row">
            <!-- 电子邮件卡片 -->
            <div class="info-card scroll-animate fade-up" data-delay="150">
              <div class="info-icon-wrap">
                <img src="@/assets/pic/contact-icon1-4.svg" alt="Email" class="info-svg" />
              </div>
              <h3>{{ $i18n.t('contact.emailTitle') }}</h3>
              <p>{{ $i18n.t('contact.emailValue') }}</p>
            </div>

            <!-- 在线客服卡片（跳转外接客服） -->
            <a 
              :href="customerServiceUrl" 
              target="_blank" 
              class="info-card customer-card scroll-animate fade-up" 
              data-delay="250"
            >
              <div class="customer-card-header">
                <div class="info-icon-wrap customer-icon-wrap">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="info-svg">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </div>
              
              </div>
              <h3>在线客服</h3>
              <div class="action-link">
                <span>立即咨询</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </a>
          </div>

          <!-- 下排：公司地址（独占一整行） -->
          <div class="bottom-row">
            <div class="info-card address-card scroll-animate fade-up" data-delay="350">
              <div class="info-icon-wrap">
                <img src="@/assets/pic/contact-icon1-1.svg" alt="Address" class="info-svg" />
              </div>
              <h3>{{ $i18n.t('contact.addressTitle') }}</h3>
              <p>{{ $i18n.t('contact.addressValueCN') }}</p>
              <p >{{ $i18n.t('contact.addressValueEN') }}</p>
            </div>
          </div>
        </div>

        <!-- 公司位置：地图区域 -->
        <div class="map-section scroll-animate fade-up" data-delay="100">
          <div class="map-card">
            <h3>{{ $i18n.t('contact.mapTitle') }}</h3>
            <p class="map-desc">{{ $i18n.t('contact.mapDesc') }}</p>
            <div class="map-wrapper scroll-animate fade-up" data-delay="200">
              <img src="@/assets/pic/map.jpg" alt="公司位置地图" class="map-img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { useScrollAnimation } from '../composables/useScrollAnimation'
useScrollAnimation()

// 外接客服链接
const customerServiceUrl = 'https://log.ztctjr.com/chat/index?channelId=cc7238b3e88744828339a302b2b34c3e'
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
}

/* ====== 横幅区域 ====== */
.banner-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(0, 20, 40, 0.85) 0%, rgba(0, 20, 40, 0.7) 60%, transparent 100%);
  pointer-events: none;
  z-index: 1;
}

.banner-img {
  width: 100%;
  object-fit: cover;
  display: block;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 12rem;
  transform: translateY(-50%);
  z-index: 2;
}

.banner-title {
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 0.75rem;
  letter-spacing: 0.125rem;
}

.banner-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 31.25rem;
}

/* ====== 容器 ====== */
.container {
  max-width: 87rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

/* ====== 区域标题 ====== */
.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}

.secTitle {
  font-size: 1.75rem;
  font-weight: bold;
  color: #1a3a5c;
  display: inline-block;
  position: relative;
  padding-bottom: 1.1rem;
  margin-bottom: 0;
}

.secTitle::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.1875rem;
  background-color: #4779B5;
  border-radius: 0.0625rem;
}

.section-header span {
  font-size: 1rem;
  color: #999;
  letter-spacing: 0.1875rem;
  margin-top: 0.625rem;
}

/* ====== 主内容区域 ====== */
.main-section {
  padding: 5rem 0;
  background-color: #fff;
}

/* ====== 联系方式布局 (上平铺、下独占) ====== */
.info-layout {
  display: flex;
  flex-direction: column;
  gap: 1.875rem;
  margin-bottom: 3rem;
}

.top-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.875rem;
}

.bottom-row {
  width: 100%;
}

.info-card {
  display: flex;
  flex-direction: column;
  padding: 2rem 1.875rem;
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.08), 0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-decoration: none;
  color: inherit;
}

.address-card {
  width: 100%;
}

.info-card:hover {
  transform: translateY(-0.1875rem);
  box-shadow: 0 0.625rem 1.5rem rgba(71, 121, 181, 0.12);
}

/* 圆形图标背景 */
.info-icon-wrap {
  width: 3.125rem;
  height: 3.125rem;
  background-color: rgba(71, 121, 181, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.info-svg {
  width: 1.5rem;
  height: 1.5rem;
  color: #4779B5;
}

.info-card h3 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.75rem;
}

.info-card p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #555;
}

.info-card p + p {
  margin-top: 0.375rem;
}

/* ====== 在线客服卡片定制样式 ====== */
.customer-card {
  border: 1.5px solid rgba(201, 169, 110, 0.4);
  background: linear-gradient(135deg, #ffffff 0%, #fcf8f0 100%);
  position: relative;
  cursor: pointer;
}

.customer-card:hover {
  border-color: #c9a96e;
  box-shadow: 0 0.625rem 1.5rem rgba(201, 169, 110, 0.25);
}

.customer-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.customer-icon-wrap {
  background-color: rgba(201, 169, 110, 0.15);
}

.customer-icon-wrap .info-svg {
  color: #c9a96e;
}

/* 在线状态点 */
.online-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  background-color: rgba(82, 196, 26, 0.1);
  color: #52c41a;
  border-radius: 1rem;
  font-size: 0.8125rem;
  font-weight: 500;
}

.online-badge .dot {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #52c41a;
  border-radius: 50%;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
}

/* 咨询箭头按钮 */
.action-link {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 1rem;
  color: #c9a96e;
  font-weight: 600;
  font-size: 1rem;
  transition: gap 0.3s ease;
}

.customer-card:hover .action-link {
  gap: 0.75rem;
}

/* ====== 地图区域 ====== */
.map-section {
  margin-top: 4rem;
}

.map-card {
  padding: 2rem 1.875rem;
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.08), 0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.05);
}

.map-card h3 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.625rem;
}

.map-desc {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 1.25rem;
}

.map-wrapper {
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
}

.map-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ====== 响应式设计 ====== */
@media (max-width: 48rem) {
  .banner-section {
    height: 17.5rem;
  }

  .banner-img {
    height: 17.5rem;
  }

  .banner-content {
    left: 1.875rem;
  }

  .banner-title {
    font-size: 1.5rem;
  }

  .banner-subtitle {
    font-size: 1rem;
  }

  .main-section {
    padding: 3.125rem 0;
  }

  .top-row {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .info-layout {
    gap: 1.5rem;
  }
}

@media (max-width: 30rem) {
  .banner-title {
    font-size: 1.5rem;
  }
}
</style>